const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de historial de salidas',
  PAGE_DESCRIPTION:
    'En esta página puedes ver un historial de todas las salidas del almacén seleccionado así como filtrar toda esa información por un rango de fechas.'
};

export default HELPER_TEXTS;
